// import { RelatedArticles } from './realatedArticle';
// import { useState, useRef, useEffect, useCallback, useMemo } from 'react';
// import { Clock, Play, Pause, Volume2 } from 'lucide-react';

// export const TestScreen = ({
//   testData,
//   currentQuestion,
//   answers,
//   timer,
//   relatedArticles,
//   handleAnswerSelect,
//   nextQuestion,
//   previousQuestion,
//   submitTest,
//   resetTest,
//   startTest,
//   jumpToQuestion
// }) => {
//   // Consolidated state management
//   const [state, setState] = useState({
//     testStarted: false,
//     speaking: false,
//     currentWordIndex: -1,
//     lastStoppedIndex: -1,
//     speechRate: 1,
//     highlightRate: 440,
//     hoveredWord: null,
//     translation: '',
//     modalPosition: { top: 0, left: 0 },
//     isModalOpen: false,
//     targetLanguage: 'hindi',
//     loading: false,
//     error: null,
//     currentChunk: 0,
//     // Media player states
//     audioPlaying: false,
//     videoPlaying: false,
//     audioCurrentTime: 0,
//     audioDuration: 0,
//     videoCurrentTime: 0,
//     videoDuration: 0
//   });

//   const [translationCache, setTranslationCache] = useState({});
//   const [chunks, setChunks] = useState([]);
  
//   const utteranceRef = useRef(null);
//   const timerRef = useRef(null);
//   const highlightIntervalRef = useRef(null);
//   const audioRef = useRef(null);
//   const videoRef = useRef(null);
//   const isMountedRef = useRef(true);
  
//   // Dummy media URLs
  // const audioUrl = "https://www.soundjay.com/misc/sounds/bell-ringing-05.wav";
  // const videoUrl = "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4";
  
//   // Memoized values
//   const actualWords = useMemo(() => {
//     return testData?.passage ? testData.passage.split(/\s+/) : [];
//   }, [testData?.passage]);

//   const styles = useMemo(() => ({
//     card: {
//       backgroundColor: 'white',
//       borderRadius: '12px',
//       boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
//       padding: '32px'
//     },
//     button: {
//       backgroundColor: '#2563eb',
//       color: 'white',
//       fontWeight: '600',
//       padding: '12px 32px',
//       borderRadius: '8px',
//       border: 'none',
//       cursor: 'pointer',
//       fontSize: '16px',
//       transition: 'background-color 0.2s'
//     },
//     buttonHover: {
//       backgroundColor: '#1d4ed8'
//     },
//     buttonSecondary: {
//       backgroundColor: '#4b5563',
//       color: 'white'
//     },
//     buttonSecondaryHover: {
//       backgroundColor: '#374151'
//     },
//     buttonSuccess: {
//       backgroundColor: '#16a34a',
//       color: 'white'
//     },
//     buttonSuccessHover: {
//       backgroundColor: '#15803d'
//     },
//     buttonWarning: {
//       backgroundColor: '#ea580c',
//       color: 'white'
//     },
//     buttonWarningHover: {
//       backgroundColor: '#c2410c'
//     },
//     buttonDisabled: {
//       backgroundColor: '#d1d5db',
//       color: 'white',
//       cursor: 'not-allowed'
//     },
//     passageContainer: {
//       marginBottom: '32px',
//       padding: '24px',
//       backgroundColor: '#f9fafb',
//       borderRadius: '8px'
//     },
//     mediaContainer: {
//       marginTop: '24px',
//       padding: '20px',
//       backgroundColor: '#ffffff',
//       borderRadius: '8px',
//       border: '1px solid #e5e7eb'
//     },
//     mediaPlayer: {
//       marginBottom: '20px',
//       padding: '16px',
//       backgroundColor: '#f8fafc',
//       borderRadius: '8px',
//       border: '1px solid #e2e8f0'
//     },
//     mediaTitle: {
//       fontSize: '16px',
//       fontWeight: '600',
//       marginBottom: '12px',
//       color: '#1f2937',
//       display: 'flex',
//       alignItems: 'center',
//       gap: '8px'
//     },
//     customPlayer: {
//       width: '100%',
//       backgroundColor: '#1f2937',
//       borderRadius: '8px',
//       padding: '16px',
//       color: 'white'
//     },
//     playerControls: {
//       display: 'flex',
//       alignItems: 'center',
//       gap: '12px',
//       marginBottom: '12px'
//     },
//     playButton: {
//       backgroundColor: '#2563eb',
//       color: 'white',
//       border: 'none',
//       borderRadius: '50%',
//       width: '40px',
//       height: '40px',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       cursor: 'pointer',
//       transition: 'background-color 0.2s'
//     },
//     progressContainer: {
//       flex: 1,
//       backgroundColor: '#374151',
//       height: '8px',
//       borderRadius: '4px',
//       position: 'relative',
//       cursor: 'pointer'
//     },
//     progressBar: {
//       backgroundColor: '#2563eb',
//       height: '100%',
//       borderRadius: '4px',
//       transition: 'width 0.1s'
//     },
//     timeDisplay: {
//       fontSize: '14px',
//       color: '#9ca3af',
//       minWidth: '45px'
//     },
//     videoPlayer: {
//       width: '100%',
//       maxHeight: '300px',
//       borderRadius: '8px'
//     },
//     questionTitle: {
//       fontSize: '20px',
//       fontWeight: '600',
//       marginBottom: '24px'
//     },
//     optionLabel: {
//       display: 'flex',
//       alignItems: 'center',
//       padding: '16px',
//       border: '1px solid #e5e7eb',
//       borderRadius: '8px',
//       marginBottom: '12px',
//       cursor: 'pointer',
//       transition: 'background-color 0.2s'
//     },
//     optionLabelHover: {
//       backgroundColor: '#f9fafb'
//     },
//     timerContainer: {
//       display: 'flex',
//       alignItems: 'center',
//       gap: '8px',
//       backgroundColor: '#dbeafe',
//       padding: '8px 16px',
//       borderRadius: '8px'
//     },
//     timerText: {
//       fontWeight: '600',
//       color: '#2563eb'
//     },
//     word: {
//       cursor: 'pointer',
//       borderBottom: '1px dotted transparent',
//       transition: 'border-color 0.2s'
//     },
//     highlightedWord: {
//       backgroundColor: '#FFEB3B',
//       padding: '0 2px',
//       borderRadius: '4px'
//     },
//     languageSelector: {
//       padding: '8px',
//       borderRadius: '4px',
//       border: '1px solid #ccc',
//       marginBottom: '16px',
//       width: '150px'
//     },
//     stopButton: {
//       backgroundColor: '#f44336',
//       color: 'white',
//       fontWeight: '600',
//       padding: '8px 16px',
//       borderRadius: '8px',
//       border: 'none',
//       cursor: 'pointer',
//       fontSize: '14px'
//     },
//     resetButton: {
//       backgroundColor: '#e0e0e0',
//       color: '#333',
//       fontWeight: '600',
//       padding: '8px 16px',
//       borderRadius: '8px',
//       border: 'none',
//       cursor: 'pointer',
//       fontSize: '14px'
//     },
//     questionNavigation: {
//       display: 'flex',
//       flexWrap: 'wrap',
//       gap: '8px',
//       margin: '24px 0',
//       justifyContent: 'center'
//     },
//     questionCircle: {
//       width: '40px',
//       height: '40px',
//       borderRadius: '50%',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       cursor: 'pointer',
//       fontWeight: '600',
//       transition: 'all 0.2s ease',
//       border: '2px solid transparent'
//     },
//     currentQuestionCircle: {
//       borderColor: '#2563eb',
//       transform: 'scale(1.1)'
//     },
//     attemptedQuestion: {
//       backgroundColor: '#16a34a',
//       color: 'white'
//     },
//     unattemptedQuestion: {
//       backgroundColor: '#f9fafb',
//       color: '#4b5563',
//       border: '2px solid #e5e7eb'
//     },
//     skippedQuestion: {
//       backgroundColor: '#f44336',
//       color: 'white'
//     }
//   }), []);

//   // Safe state update function
//   const updateState = useCallback((updates) => {
//     if (isMountedRef.current) {
//       setState(prevState => ({ ...prevState, ...updates }));
//     }
//   }, []);

//   // Cleanup function
//   const cleanup = useCallback(() => {
//     if (utteranceRef.current) {
//       speechSynthesis.cancel();
//     }
//     if (highlightIntervalRef.current) {
//       clearInterval(highlightIntervalRef.current);
//       highlightIntervalRef.current = null;
//     }
//     if (timerRef.current) {
//       clearTimeout(timerRef.current);
//       timerRef.current = null;
//     }
//   }, []);

//   // Media player functions with safe updates
//   const toggleAudioPlay = useCallback(() => {
//     if (audioRef.current && isMountedRef.current) {
//       if (state.audioPlaying) {
//         audioRef.current.pause();
//       } else {
//         audioRef.current.play();
//       }
//       updateState({ audioPlaying: !state.audioPlaying });
//     }
//   }, [state.audioPlaying, updateState]);

//   const toggleVideoPlay = useCallback(() => {
//     if (videoRef.current && isMountedRef.current) {
//       if (state.videoPlaying) {
//         videoRef.current.pause();
//       } else {
//         videoRef.current.play();
//       }
//       updateState({ videoPlaying: !state.videoPlaying });
//     }
//   }, [state.videoPlaying, updateState]);

//   const handleAudioTimeUpdate = useCallback(() => {
//     if (audioRef.current && isMountedRef.current) {
//       updateState({ audioCurrentTime: audioRef.current.currentTime });
//     }
//   }, [updateState]);

//   const handleVideoTimeUpdate = useCallback(() => {
//     if (videoRef.current && isMountedRef.current) {
//       updateState({ videoCurrentTime: videoRef.current.currentTime });
//     }
//   }, [updateState]);

//   const handleAudioLoadedMetadata = useCallback(() => {
//     if (audioRef.current && isMountedRef.current) {
//       updateState({ audioDuration: audioRef.current.duration });
//     }
//   }, [updateState]);

//   const handleVideoLoadedMetadata = useCallback(() => {
//     if (videoRef.current && isMountedRef.current) {
//       updateState({ videoDuration: videoRef.current.duration });
//     }
//   }, [updateState]);

//   const handleAudioProgressClick = useCallback((e) => {
//     if (audioRef.current && isMountedRef.current) {
//       const rect = e.currentTarget.getBoundingClientRect();
//       const clickX = e.clientX - rect.left;
//       const newTime = (clickX / rect.width) * state.audioDuration;
//       audioRef.current.currentTime = newTime;
//       updateState({ audioCurrentTime: newTime });
//     }
//   }, [state.audioDuration, updateState]);

//   const handleVideoProgressClick = useCallback((e) => {
//     if (videoRef.current && isMountedRef.current) {
//       const rect = e.currentTarget.getBoundingClientRect();
//       const clickX = e.clientX - rect.left;
//       const newTime = (clickX / rect.width) * state.videoDuration;
//       videoRef.current.currentTime = newTime;
//       updateState({ videoCurrentTime: newTime });
//     }
//   }, [state.videoDuration, updateState]);

//   const formatTime = useCallback((seconds) => {
//     const mins = Math.floor(seconds / 60);
//     const secs = Math.floor(seconds % 60);
//     return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
//   }, []);

//   const handleStartTest = useCallback(() => {
//     updateState({ testStarted: true });
//     startTest();
//   }, [updateState, startTest]);

//   // Helper function to split text into manageable chunks
//   const splitTextIntoChunks = useCallback((text, wordsPerChunk = 20) => {
//     const words = text.split(/\s+/).filter(word => word.trim().length > 0);
//     const chunks = [];
    
//     for (let i = 0; i < words.length; i += wordsPerChunk) {
//       chunks.push(words.slice(i, i + wordsPerChunk).join(' '));
//     }
    
//     return chunks;
//   }, []);

//   // Initialize chunks when testData changes
//   useEffect(() => {
//     if (testData?.passage && isMountedRef.current) {
//       const newChunks = splitTextIntoChunks(testData.passage);
//       setChunks(newChunks);
//       updateState({
//         currentChunk: 0,
//         lastStoppedIndex: -1,
//         currentWordIndex: -1
//       });
//     }
//   }, [testData?.passage, splitTextIntoChunks, updateState]);

//   // Function to speak a specific chunk
//   const speakChunk = useCallback((chunkIndex) => {
//     if (chunkIndex >= chunks.length || !chunks[chunkIndex] || !isMountedRef.current) {
//       // Finished all chunks
//       updateState({
//         speaking: false,
//         currentWordIndex: -1,
//         currentChunk: 0,
//         lastStoppedIndex: -1
//       });
//       if (highlightIntervalRef.current) {
//         clearInterval(highlightIntervalRef.current);
//         highlightIntervalRef.current = null;
//       }
//       return;
//     }

//     const utterance = new SpeechSynthesisUtterance(chunks[chunkIndex]);
//     utteranceRef.current = utterance;
//     utterance.rate = state.speechRate;

//     // Calculate word positions for this chunk
//     const wordsPerChunk = 20;
//     const startWordIndex = chunkIndex * wordsPerChunk;
//     let currentWordInChunk = 0;
//     const wordsInThisChunk = Math.min(wordsPerChunk, actualWords.length - startWordIndex);

//     // Clear any existing interval
//     if (highlightIntervalRef.current) {
//       clearInterval(highlightIntervalRef.current);
//       highlightIntervalRef.current = null;
//     }

//     // Set initial word for immediate highlighting
//     if (startWordIndex < actualWords.length && isMountedRef.current) {
//       updateState({ currentWordIndex: startWordIndex });
//       currentWordInChunk = 1;
//     }

//     // Highlight subsequent words as they're spoken
//     highlightIntervalRef.current = setInterval(() => {
//       if (!isMountedRef.current) {
//         clearInterval(highlightIntervalRef.current);
//         highlightIntervalRef.current = null;
//         return;
//       }
      
//       if (currentWordInChunk < wordsInThisChunk && startWordIndex + currentWordInChunk < actualWords.length) {
//         updateState({ currentWordIndex: startWordIndex + currentWordInChunk });
//         currentWordInChunk++;
//       } else {
//         clearInterval(highlightIntervalRef.current);
//         highlightIntervalRef.current = null;
//       }
//     }, state.highlightRate);

//     utterance.onend = () => {
//       if (!isMountedRef.current) return;
      
//       if (highlightIntervalRef.current) {
//         clearInterval(highlightIntervalRef.current);
//         highlightIntervalRef.current = null;
//       }
      
//       const nextChunk = chunkIndex + 1;
//       updateState({
//         currentChunk: nextChunk,
//         lastStoppedIndex: startWordIndex + wordsInThisChunk
//       });
      
//       // Continue to next chunk automatically if still speaking and more chunks exist
//       if (nextChunk < chunks.length) {
//         timerRef.current = setTimeout(() => {
//           if (isMountedRef.current) {
//             speakChunk(nextChunk);
//           }
//         }, 100);
//       } else {
//         // Finished all chunks
//         updateState({
//           speaking: false,
//           currentWordIndex: -1,
//           lastStoppedIndex: -1,
//           currentChunk: 0
//         });
//       }
//     };

//     utterance.onerror = (event) => {
//       console.error('Speech error:', event);
//       if (!isMountedRef.current) return;
      
//       if (highlightIntervalRef.current) {
//         clearInterval(highlightIntervalRef.current);
//         highlightIntervalRef.current = null;
//       }
//       updateState({
//         speaking: false,
//         currentWordIndex: -1
//       });
//     };

//     speechSynthesis.speak(utterance);
//   }, [chunks, state.speechRate, state.highlightRate, actualWords.length, updateState]);

//   // Main speech function
//   const startSpeech = useCallback(() => {
//     if (!speechSynthesis) {
//       alert("Sorry, your browser doesn't support the Web Speech API");
//       return;
//     }

//     if (state.speaking) {
//       cleanup();
//       updateState({ speaking: false });
//       return;
//     }

//     // If we've finished all chunks, restart from beginning
//     const chunkToStart = state.currentChunk >= chunks.length ? 0 : state.currentChunk;
//     if (chunkToStart === 0) {
//       updateState({ lastStoppedIndex: 0 });
//     }

//     updateState({ speaking: true });
//     speakChunk(chunkToStart);
//   }, [state.speaking, state.currentChunk, chunks.length, cleanup, updateState, speakChunk]);

//   // Stop speech function
//   const stopSpeech = useCallback(() => {
//     cleanup();
//     updateState({ speaking: false });
//   }, [cleanup, updateState]);

//   // Reset speech function
//   const resetSpeech = useCallback(() => {
//     cleanup();
//     updateState({
//       speaking: false,
//       currentChunk: 0,
//       currentWordIndex: -1,
//       lastStoppedIndex: -1
//     });
//   }, [cleanup, updateState]);

//   // Cleanup on unmount
//   useEffect(() => {
//     return () => {
//       isMountedRef.current = false;
//       cleanup();
//     };
//   }, [cleanup]);

//   // Render passage with words for highlighting
//   const renderPassage = useCallback(() => {
//     if (!testData?.passage) return null;
    
//     const words = testData.passage.split(/(\s+)/);
//     let wordIndex = 0;
    
//     return words.map((part, index) => {
//       const isWord = !/^\s+$/.test(part) && part.trim().length > 0;
      
//       if (!isWord) {
//         return <span key={`space-${index}`}>{part}</span>;
//       }
      
//       const isHighlighted = state.currentWordIndex === wordIndex;
//       const currentWordPosition = wordIndex;
//       wordIndex++;
      
//       return (
//         <span
//           key={`word-${index}-${currentWordPosition}`}
//           style={{
//             ...styles.word,
//             ...(isHighlighted ? styles.highlightedWord : {}),
//             borderBottom: '1px dotted #ccc'
//           }}
//           onMouseOver={(e) => {
//             e.target.style.borderBottomColor = '#007bff';
//           }}
//           onMouseOut={(e) => {
//             e.target.style.borderBottomColor = '#ccc';
//           }}
//         >
//           {part}
//         </span>
//       );
//     });
//   }, [testData?.passage, state.currentWordIndex, styles.word, styles.highlightedWord]);

//   // Render question navigation circles
//   const renderQuestionNavigation = useCallback(() => {
//     if (!testData?.questions) return null;
    
//     return (
//       <div style={styles.questionNavigation}>
//         {testData.questions.map((question, index) => {
//           const isAttempted = answers[question.id] !== undefined;
//           const isCurrent = currentQuestion === index;
          
//           let circleStyle = {
//             ...styles.questionCircle,
//             ...(isCurrent ? styles.currentQuestionCircle : {}),
//             ...(isAttempted ? styles.attemptedQuestion : styles.unattemptedQuestion)
//           };
          
//           const isSkipped = !isAttempted && index < currentQuestion;
//           if (isSkipped) {
//             circleStyle = {
//               ...circleStyle,
//               ...styles.skippedQuestion
//             };
//           }
          
//           return (
//             <div
//               key={question.id}
//               style={circleStyle}
//               onClick={() => jumpToQuestion(index)}
//               title={`Question ${index + 1}`}
//             >
//               {index + 1}
//             </div>
//           );
//         })}
//       </div>
//     );
//   }, [testData?.questions, answers, currentQuestion, styles, jumpToQuestion]);

//   // Render media players
//   const renderMediaPlayers = useCallback(() => {
//     return (
//       <div style={styles.mediaContainer}>
//         <h4 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '20px', color: '#1f2937' }}>
//           Additional Learning Resources
//         </h4>
        
//         {/* Audio Player */}
//         <div style={styles.mediaPlayer}>
//           <div style={styles.mediaTitle}>
//             <Volume2 size={20} />
//             Audio Explanation - Depreciation Concepts
//           </div>
//           <div style={styles.customPlayer}>
//             <div style={styles.playerControls}>
//               <button 
//                 onClick={toggleAudioPlay}
//                 style={styles.playButton}
//                 onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#1d4ed8'}
//                 onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#2563eb'}
//               >
//                 {state.audioPlaying ? <Pause size={20} /> : <Play size={20} />}
//               </button>
//               <div 
//                 style={styles.progressContainer}
//                 onClick={handleAudioProgressClick}
//               >
//                 <div 
//                   style={{
//                     ...styles.progressBar,
//                     width: `${state.audioDuration ? (state.audioCurrentTime / state.audioDuration) * 100 : 0}%`
//                   }}
//                 />
//               </div>
//               <span style={styles.timeDisplay}>
//                 {formatTime(state.audioCurrentTime)} / {formatTime(state.audioDuration)}
//               </span>
//             </div>
//             <audio
//               ref={audioRef}
//               src={audioUrl}
//               onTimeUpdate={handleAudioTimeUpdate}
//               onLoadedMetadata={handleAudioLoadedMetadata}
//               onPlay={() => updateState({ audioPlaying: true })}
//               onPause={() => updateState({ audioPlaying: false })}
//               onEnded={() => updateState({ audioPlaying: false })}
//               style={{ display: 'none' }}
//             />
//           </div>
//         </div>

//         {/* Video Player */}
//         <div style={styles.mediaPlayer}>
//           <div style={styles.mediaTitle}>
//             <Play size={20} />
//             Video Tutorial - Depreciation Methods
//           </div>
//           <div style={styles.customPlayer}>
//             <video
//               ref={videoRef}
//               src={videoUrl}
//               style={styles.videoPlayer}
//               controls
//               onTimeUpdate={handleVideoTimeUpdate}
//               onLoadedMetadata={handleVideoLoadedMetadata}
//               onPlay={() => updateState({ videoPlaying: true })}
//               onPause={() => updateState({ videoPlaying: false })}
//               onEnded={() => updateState({ videoPlaying: false })}
//             />
//           </div>
//         </div>
//       </div>
//     );
//   }, [
//     styles,
//     state.audioPlaying,
//     state.audioCurrentTime,
//     state.audioDuration,
//     toggleAudioPlay,
//     handleAudioProgressClick,
//     formatTime,
//     handleAudioTimeUpdate,
//     handleAudioLoadedMetadata,
//     handleVideoTimeUpdate,
//     handleVideoLoadedMetadata,
//     updateState
//   ]);

//   if (!state.testStarted) {
//     return (
//       <div style={{ display: 'flex', flexDirection: 'row', gap: '32px' }}>
//         <div style={{ flex: '2 1 0%', minWidth: 0 }}>
//           <div style={styles.card}>
//             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
//               <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#1f2937' }}>Depreciation Test</h2>
//               <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
//                 <div style={styles.timerContainer}>
//                   <Clock style={{ width: '20px', height: '20px', color: '#2563eb' }} />
//                   <span style={styles.timerText}>{formatTime(timer)}</span>
//                 </div>
//               </div>
//             </div>
            
//             <div style={styles.passageContainer}>
//               <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
//                 <h3 style={{ fontWeight: '700' }}>Read the following passage:</h3>
//                 <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//                   <select 
//                     value={state.targetLanguage}
//                     onChange={(e) => updateState({ targetLanguage: e.target.value })}
//                     style={styles.languageSelector}
//                   >
//                     <option value="hindi">Hindi</option>
//                     <option value="spanish">Spanish</option>
//                     <option value="french">French</option>
//                     <option value="german">German</option>
//                     <option value="chinese">Chinese</option>
//                     <option value="japanese">Japanese</option>
//                   </select>
//                   <button
//                     onClick={startSpeech}
//                     style={{
//                       ...styles.button,
//                       padding: '8px 16px',
//                       fontSize: '14px'
//                     }}
//                   >
//                     {state.speaking ? 'Stop Reading' : state.lastStoppedIndex > 0 ? 'Resume Reading' : 'Start Reading'}
//                   </button>
//                   {state.speaking && (
//                     <button
//                       onClick={stopSpeech}
//                       style={styles.stopButton}
//                     >
//                       Stop
//                     </button>
//                   )}
//                   {state.lastStoppedIndex > 0 && !state.speaking && (
//                     <button
//                       onClick={resetSpeech}
//                       style={styles.resetButton}
//                     >
//                       Reset
//                     </button>
//                   )}
//                 </div>
//               </div>
//               <div style={{ color: '#4b5563', lineHeight: '1.625' }}>
//                 {renderPassage()}
//               </div>
              
//               {renderMediaPlayers()}
//             </div>
            
//             <div style={{ textAlign: 'center', marginTop: '32px' }}>
//               <button
//                 onClick={handleStartTest}
//                 style={styles.button}
//                 onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.buttonHover.backgroundColor}
//                 onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.button.backgroundColor}
//               >
//                 Start Test
//               </button>
//             </div>
//           </div>
//         </div>
        
//         <div style={{ flex: '1 1 0%', minWidth: '300px' }}>
//           {relatedArticles && <RelatedArticles articles={relatedArticles} />}
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div style={{ display: 'flex', flexDirection: 'row', gap: '32px' }}>
//       <div style={{ flex: '2 1 0%', minWidth: 0 }}>
//         <div style={styles.card}>
//           <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
//             <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#1f2937' }}>Depreciation Test</h2>
//             <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
//               <div style={styles.timerContainer}>
//                 <Clock style={{ width: '20px', height: '20px', color: '#2563eb' }} />
//                 <span style={styles.timerText}>{formatTime(timer)}</span>
//               </div>
//               <span style={{ color: '#4b5563' }}>
//                 Question {currentQuestion + 1} of {testData?.questions?.length || 0}
//               </span>
//             </div>
//           </div>
          
//           <div style={styles.passageContainer}>
//             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
//               <h3 style={{ fontWeight: '700' }}>Reading Passage:</h3>
//             </div>
//             <div style={{ color: '#4b5563', lineHeight: '1.625' }}>
//               {renderPassage()}
//             </div>
            
//             {renderMediaPlayers()}
//           </div>
          
//           {renderQuestionNavigation()}
          
//           {/* Questions section */}
//           <div style={{ marginBottom: '32px' }}>
//             <h3 style={styles.questionTitle}>{testData.questions[currentQuestion].question}</h3>
//             <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
//               {testData.questions[currentQuestion].options.map((option, index) => (
//                 <label 
//                   key={index} 
//                   style={{
//                     ...styles.optionLabel,
//                     ...(answers[testData.questions[currentQuestion].id] === index ? { backgroundColor: '#e6f7ff' } : {}),
//                     ':hover': styles.optionLabelHover
//                   }}
//                 >
//                   <input
//                     type="radio"
//                     name={`question-${testData.questions[currentQuestion].id}`}
//                     value={index}
//                     checked={answers[testData.questions[currentQuestion].id] === index}
//                     onChange={() => handleAnswerSelect(testData.questions[currentQuestion].id, index)}
//                     style={{ marginRight: '16px' }}
//                   />
//                   <span>{option}</span>
//                 </label>
//               ))}
//             </div>
//           </div>
          
//           <div style={{ display: 'flex', justifyContent: 'space-between' }}>
//             <div style={{ display: 'flex', gap: '16px' }}>
//               <button
//                 onClick={resetTest}
//                 style={{
//                   ...styles.button,
//                   ...styles.buttonSecondary
//                 }}
//                 onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.buttonSecondaryHover.backgroundColor}
//                 onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.buttonSecondary.backgroundColor}
//               >
//                 Reset Test
//               </button>
              
//               {currentQuestion > 0 && (
//                 <button
//                   onClick={previousQuestion}
//                   style={{
//                     ...styles.button,
//                     ...styles.buttonWarning
//                   }}
//                   onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.buttonWarningHover.backgroundColor}
//                   onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.buttonWarning.backgroundColor}
//                 >
//                   Previous Question
//                 </button>
//               )}
//             </div>
            
//             {currentQuestion < testData.questions.length - 1 ? (
//               <button
//                 onClick={nextQuestion}
//                 style={{
//                   ...styles.button,
//                   ...(answers[testData.questions[currentQuestion].id] === undefined ? styles.buttonDisabled : {}),
//                   ':hover': answers[testData.questions[currentQuestion].id] === undefined ? {} : styles.buttonHover
//                 }}
//                 onMouseOver={(e) => {
//                   if (answers[testData.questions[currentQuestion].id] !== undefined) {
//                     e.currentTarget.style.backgroundColor = styles.buttonHover.backgroundColor;
//                   }
//                 }}
//                 onMouseOut={(e) => {
//                   if (answers[testData.questions[currentQuestion].id] !== undefined) {
//                     e.currentTarget.style.backgroundColor = styles.button.backgroundColor;
//                   }
//                 }}
//               >
//                 Next Question
//               </button>
//             ) : (
//               <button
//                 onClick={submitTest}
//                 disabled={Object.keys(answers).length === 0}
//                 style={{
//                   ...styles.button,
//                   ...styles.buttonSuccess,
//                   ...(Object.keys(answers).length === 0 ? styles.buttonDisabled : {}),
//                   ':hover': Object.keys(answers).length === 0 ? {} : styles.buttonSuccessHover
//                 }}
//                 onMouseOver={(e) => {
//                   if (Object.keys(answers).length !== 0) {
//                     e.currentTarget.style.backgroundColor = styles.buttonSuccessHover.backgroundColor;
//                   }
//                 }}
//                 onMouseOut={(e) => {
//                   if (Object.keys(answers).length !== 0) {
//                     e.currentTarget.style.backgroundColor = styles.buttonSuccess.backgroundColor;
//                   }
//                 }}
//               >
//                 Submit Test
//               </button>
//             )}
//           </div>
//         </div>
//       </div>
      
//       {/* Right Side - Related Articles */}
//       <div style={{ flex: '1 1 0%', minWidth: '300px' }}>
//         <RelatedArticles articles={relatedArticles} />
//       </div>
//     </div>
//   );
// };




// import { RelatedArticles } from './relatedArticle';
import { RelatedArticles } from './realatedArticle';
// import { SpeechHighlighter } from './SpeechHighlighter'; // Import the new component
import { SpeechHighlighter } from './speechhighlighter';
import { useState, useCallback, useMemo } from 'react';
import { Clock } from 'lucide-react';

export const TestScreen = ({
  testData,
  currentQuestion,
  answers,
  timer,
  relatedArticles,
  handleAnswerSelect,
  handleFillBlankInput,
  nextQuestion,
  previousQuestion,
  submitTest,
  resetTest,
  startTest,
  jumpToQuestion
}) => {
  // Simplified state management
  const [state, setState] = useState({
    testStarted: false
  });

  const styles = useMemo(() => ({
    card: {
      backgroundColor: 'white',
      borderRadius: '12px',
      boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
      padding: '32px'
    },
    button: {
      backgroundColor: '#2563eb',
      color: 'white',
      fontWeight: '600',
      padding: '12px 32px',
      borderRadius: '8px',
      border: 'none',
      cursor: 'pointer',
      fontSize: '16px',
      transition: 'background-color 0.2s'
    },
    buttonHover: {
      backgroundColor: '#1d4ed8'
    },
    buttonSecondary: {
      backgroundColor: '#4b5563',
      color: 'white'
    },
    buttonSecondaryHover: {
      backgroundColor: '#374151'
    },
    buttonSuccess: {
      backgroundColor: '#16a34a',
      color: 'white'
    },
    buttonSuccessHover: {
      backgroundColor: '#15803d'
    },
    buttonWarning: {
      backgroundColor: '#ea580c',
      color: 'white'
    },
    buttonWarningHover: {
      backgroundColor: '#c2410c'
    },
    buttonDisabled: {
      backgroundColor: '#d1d5db',
      color: 'white',
      cursor: 'not-allowed'
    },
    passageContainer: {
      marginBottom: '32px',
      backgroundColor: '#f9fafb',
      borderRadius: '8px'
    },
    questionTitle: {
      fontSize: '20px',
      fontWeight: '600',
      marginBottom: '24px'
    },
    optionLabel: {
      display: 'flex',
      alignItems: 'center',
      padding: '16px',
      border: '1px solid #e5e7eb',
      borderRadius: '8px',
      marginBottom: '12px',
      cursor: 'pointer',
      transition: 'background-color 0.2s'
    },
    optionLabelHover: {
      backgroundColor: '#f9fafb'
    },
    timerContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      backgroundColor: '#dbeafe',
      padding: '8px 16px',
      borderRadius: '8px'
    },
    timerText: {
      fontWeight: '600',
      color: '#2563eb'
    },
    questionNavigation: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '8px',
      margin: '24px 0',
      justifyContent: 'center'
    },
    questionCircle: {
      width: '40px',
      height: '40px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      fontWeight: '600',
      transition: 'all 0.2s ease',
      border: '2px solid transparent'
    },
    currentQuestionCircle: {
      borderColor: '#2563eb',
      transform: 'scale(1.1)'
    },
    attemptedQuestion: {
      backgroundColor: '#16a34a',
      color: 'white'
    },
    unattemptedQuestion: {
      backgroundColor: '#f9fafb',
      color: '#4b5563',
      border: '2px solid #e5e7eb'
    },
    skippedQuestion: {
      backgroundColor: '#f44336',
      color: 'white'
    }
  }), []);

  const updateState = useCallback((updates) => {
    setState(prevState => ({ ...prevState, ...updates }));
  }, []);

  const formatTime = useCallback((seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  }, []);

  const handleStartTest = useCallback(() => {
    updateState({ testStarted: true });
    startTest();
  }, [updateState, startTest]);

  // Render question navigation circles
  const renderQuestionNavigation = useCallback(() => {
    if (!testData?.questions) return null;
    
    return (
      <div style={styles.questionNavigation}>
        {testData.questions.map((question, index) => {
          const isAttempted = answers[question.id] !== undefined;
          const isCurrent = currentQuestion === index;
          
          let circleStyle = {
            ...styles.questionCircle,
            ...(isCurrent ? styles.currentQuestionCircle : {}),
            ...(isAttempted ? styles.attemptedQuestion : styles.unattemptedQuestion)
          };
          
          const isSkipped = !isAttempted && index < currentQuestion;
          if (isSkipped) {
            circleStyle = {
              ...circleStyle,
              ...styles.skippedQuestion
            };
          }
          
          return (
            <div
              key={question.id}
              style={circleStyle}
              onClick={() => jumpToQuestion(index)}
              title={`Question ${index + 1}`}
            >
              {index + 1}
            </div>
          );
        })}
      </div>
    );
  }, [testData?.questions, answers, currentQuestion, styles, jumpToQuestion]);

  const renderQuestion = () => {
    const question = testData.questions[currentQuestion];
    
    switch (question.type) {
      case 'multipleChoiceFillBlank':
        const blankMarker = '__________';
        const questionParts1 = question.question.split(blankMarker);
        
        return (
          <div style={{ marginBottom: '32px' }}>
            <h3 style={styles.questionTitle}>
              {questionParts1[0]}
              <span style={{ 
                display: 'inline-block',
                minWidth: '200px',
                position: 'relative'
              }}>
                <input
                  type="text"
                  value={answers[question.id] || ''}
                  onChange={(e) => handleFillBlankInput(question.id, e.target.value)}
                  style={{
                    padding: '8px 16px',
                    border: '2px solid #e5e7eb',
                    borderRadius: '6px',
                    fontSize: '16px',
                    fontWeight: '500',
                    backgroundColor: answers[question.id] ? '#f0f9ff' : '#ffffff',
                    borderColor: answers[question.id] ? '#3b82f6' : '#e5e7eb',
                    outline: 'none',
                    transition: 'all 0.2s ease',
                    minWidth: '180px'
                  }}
                  placeholder="Select or type answer"
                />
              </span>
              {' '}
              <span style={{ fontSize: '16px', color: '#64748b' }}>(</span>
              {question.options.map((option, index) => (
                <span key={index}>
                  <span
                    onClick={() => handleFillBlankInput(question.id, option)}
                    style={{
                      color: answers[question.id] === option ? '#3b82f6' : '#6b7280',
                      cursor: 'pointer',
                      fontSize: '16px',
                      fontWeight: answers[question.id] === option ? '600' : '400',
                      textDecoration: 'underline',
                      textDecorationStyle: 'dotted',
                      padding: '2px 4px',
                      borderRadius: '4px',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseOver={(e) => {
                      e.target.style.backgroundColor = '#f3f4f6';
                      e.target.style.color = '#374151';
                    }}
                    onMouseOut={(e) => {
                      e.target.style.backgroundColor = 'transparent';
                      e.target.style.color = answers[question.id] === option ? '#3b82f6' : '#6b7280';
                    }}
                  >
                    {option}
                  </span>
                  {index < question.options.length - 1 && (
                    <span style={{ 
                      margin: '0 6px', 
                      color: '#64748b',
                      fontSize: '16px'
                    }}>
                      /
                    </span>
                  )}
                </span>
              ))}
              <span style={{ fontSize: '16px', color: '#64748b' }}>)</span>
              {questionParts1[1]}
            </h3>
          </div>
        );

      case 'mcq':
        return (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {question.options.map((option, index) => (
              <label 
                key={index} 
                style={{
                  ...styles.optionLabel,
                  ...(answers[question.id] === index ? { backgroundColor: '#e6f7ff' } : {}),
                }}
              >
                <input
                  type="radio"
                  name={`question-${question.id}`}
                  value={index}
                  checked={answers[question.id] === index}
                  onChange={() => handleAnswerSelect(question.id, index)}
                  style={{ marginRight: '16px' }}
                />
                <span>{option}</span>
              </label>
            ))}
          </div>
        );
        
      case 'fillBlank':
        const questionParts = question.question.split(/__________/g);
        
        return (
          <div style={{ marginTop: '16px' }}>
            <div style={{ marginBottom: '16px' }}>
              {questionParts.map((part, index) => (
                <span key={`part-${index}`}>
                  {part}
                  {index < questionParts.length - 1 && (
                    <input
                      type="text"
                      value={answers[question.id]?.[index] || ''}
                      onChange={(e) => {
                        const newAnswers = [...(answers[question.id] || [])];
                        newAnswers[index] = e.target.value;
                        handleFillBlankInput(question.id, newAnswers);
                      }}
                      style={{
                        padding: '8px 12px',
                        border: '1px solid #e5e7eb',
                        borderRadius: '4px',
                        margin: '0 4px',
                        minWidth: '120px',
                        fontSize: '16px'
                      }}
                      placeholder="Answer"
                    />
                  )}
                </span>
              ))}
            </div>
          </div>
        );
        
      default:
        return null;
    }
  };

  if (!state.testStarted) {
    return (
      <div style={{ display: 'flex', flexDirection: 'row', gap: '32px' }}>
        <div style={{ flex: '2 1 0%', minWidth: 0 }}>
          <div style={styles.card}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
              <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#1f2937' }}>Depreciation Test</h2>
              <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                <div style={styles.timerContainer}>
                  <Clock style={{ width: '20px', height: '20px', color: '#2563eb' }} />
                  <span style={styles.timerText}>{formatTime(timer)}</span>
                </div>
              </div>
            </div>
            
            {/* Replace the old passage container with SpeechHighlighter */}
            <div style={styles.passageContainer}>
              <h3 style={{ fontWeight: '700', marginBottom: '16px', padding: '0 24px', paddingTop: '24px' }}>
                Read the following passage:
              </h3>
              <div style={{ padding: '0 24px 24px' }}>
                <SpeechHighlighter 
                  text={testData?.passage} 
                  style={{ marginBottom: '0' }}
                />
              </div>
            </div>
            
            <div style={{ textAlign: 'center', marginTop: '32px' }}>
              <button
                onClick={handleStartTest}
                style={styles.button}
                onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.buttonHover.backgroundColor}
                onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.button.backgroundColor}
              >
                Start Test
              </button>
            </div>
          </div>
        </div>
        
        <div style={{ flex: '1 1 0%', minWidth: '300px' }}>
          {relatedArticles && <RelatedArticles articles={relatedArticles} />}
        </div>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'row', gap: '32px' }}>
      <div style={{ flex: '2 1 0%', minWidth: 0 }}>
        <div style={styles.card}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#1f2937' }}>Depreciation Test</h2>
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <div style={styles.timerContainer}>
                <Clock style={{ width: '20px', height: '20px', color: '#2563eb' }} />
                <span style={styles.timerText}>{formatTime(timer)}</span>
              </div>
              <span style={{ color: '#4b5563' }}>
                Question {currentQuestion + 1} of {testData?.questions?.length || 0}
              </span>
            </div>
          </div>
          
          {/* Replace the old passage container with SpeechHighlighter */}
          <div style={styles.passageContainer}>
            <h3 style={{ fontWeight: '700', marginBottom: '16px', padding: '0 24px', paddingTop: '24px' }}>
              Reading Passage:
            </h3>
            <div style={{ padding: '0 24px 24px' }}>
              <SpeechHighlighter 
                text={testData?.passage} 
                style={{ marginBottom: '0' }}
              />
            </div>
          </div>
          
          {renderQuestionNavigation()}
          
          <div style={{ marginBottom: '32px' }}>
            <h3 style={styles.questionTitle}>
              {testData.questions[currentQuestion].question}
            </h3>
            {renderQuestion()}
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', gap: '16px' }}>
              <button
                onClick={resetTest}
                style={{
                  ...styles.button,
                  ...styles.buttonSecondary
                }}
                onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.buttonSecondaryHover.backgroundColor}
                onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.buttonSecondary.backgroundColor}
              >
                Reset Test
              </button>
              
              {currentQuestion > 0 && (
                <button
                  onClick={previousQuestion}
                  style={{
                    ...styles.button,
                    ...styles.buttonWarning
                  }}
                  onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.buttonWarningHover.backgroundColor}
                  onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.buttonWarning.backgroundColor}
                >
                  Previous Question
                </button>
              )}
            </div>
            
            {currentQuestion < testData.questions.length - 1 ? (
              <button
                onClick={nextQuestion}
                style={{
                  ...styles.button,
                  ...(answers[testData.questions[currentQuestion].id] === undefined ? styles.buttonDisabled : {}),
                  ':hover': answers[testData.questions[currentQuestion].id] === undefined ? {} : styles.buttonHover
                }}
                onMouseOver={(e) => {
                  if (answers[testData.questions[currentQuestion].id] !== undefined) {
                    e.currentTarget.style.backgroundColor = styles.buttonHover.backgroundColor;
                  }
                }}
                onMouseOut={(e) => {
                  if (answers[testData.questions[currentQuestion].id] !== undefined) {
                    e.currentTarget.style.backgroundColor = styles.button.backgroundColor;
                  }
                }}
              >
                Next Question
              </button>
            ) : (
              <button
                onClick={submitTest}
                disabled={Object.keys(answers).length === 0}
                style={{
                  ...styles.button,
                  ...styles.buttonSuccess,
                  ...(Object.keys(answers).length === 0 ? styles.buttonDisabled : {}),
                  ':hover': Object.keys(answers).length === 0 ? {} : styles.buttonSuccessHover
                }}
                onMouseOver={(e) => {
                  if (Object.keys(answers).length !== 0) {
                    e.currentTarget.style.backgroundColor = styles.buttonSuccessHover.backgroundColor;
                  }
                }}
                onMouseOut={(e) => {
                  if (Object.keys(answers).length !== 0) {
                    e.currentTarget.style.backgroundColor = styles.buttonSuccess.backgroundColor;
                  }
                }}
              >
                Submit Test
              </button>
            )}
          </div>
        </div>
      </div>
      
      <div style={{ flex: '1 1 0%', minWidth: '300px' }}>
        <RelatedArticles articles={relatedArticles} />
      </div>
    </div>
  );
};